var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('TixMessage',{attrs:{"type":"error"}},[_vm._v("\n  "+_vm._s(_vm.error)+"\n")]):_c('p',[_vm._v("Logging in and redirecting…")])}
var staticRenderFns = []

export { render, staticRenderFns }